import React from 'react'
import { useParams } from 'react-router-dom'
import { useStore } from '../../../../../hooks'
import ChatComponentPersistent from '../../../PMSystemPage/components/ChatComponent/ChatComponentPersistent'
import { ChatProvider } from '../../../PMSystemPage/context/ChatContext'
import { TestChatWrapper } from '../ViewPage/ViewPage.styled'
import { CreatedPageContainer, CreatedPageContent, ChatContainer } from './CreatedPage.styled'
import SettingsIcon from '@mui/icons-material/Settings'

const CreatedPage = () => {
    const { agentId } = useParams()
    const { authStore } = useStore()
    const [agentName, setAgentName] = React.useState(`Agent ${agentId}`)

    // Configuration of the placeholder for the initial chat (Build Agent)
    const buildAgentPlaceholderConfig = {
        placeholderTitle: "Build your Agent with AI support",
        placeholderDescription: "You don't need to fill out forms. Just start typing what you need, and we will guide you step by step to create a personalized Agent.",
        placeholderIcon: SettingsIcon,
        showDefaultPlaceholder: true
    }

    // HTTP Configuration
    const httpOptions = {
        tenantId: authStore.currentWorkspaceUuid || "default-tenant",
        senderUuid: authStore.currentWorkspaceUuid,
        assistantUuid: agentId,
    }

    return (
        <CreatedPageContainer>          
            <ChatContainer>
                <TestChatWrapper>
                    <ChatProvider
                        communicationType="http"
                        httpOptions={httpOptions}
                    >
                        <ChatComponentPersistent
                            customerSelected={authStore.currentWorkspaceUuid}
                            agentId={agentId}
                            agentDomain={"assistant"}
                            inputWidth="100%"
                            metadata={{}}
                            handleMetadata={() => {}}
                            agentData={{
                                id: agentId,
                                customerId: authStore.currentWorkspaceUuid,
                                jobTitle: "",
                                persona: { name: "" },
                                tone: [],
                                conversationStarters: [],
                                extendedAnswer: false,
                                scope: "",
                                actions: [],
                                actionsSettings: [],
                                name: agentName,
                                knowledgeBase: [],
                                humanInstructions: "",
                                prompt: "",
                                addToConcierge: false,
                                channels: [],
                                fullInstructions: "",
                                guardrails: [],
                                features: [],
                                instructionRef: [],
                                status: "active",
                                photoUrl: "",
                                model: "",
                                category: "",
                                signature: { EMAIL: "" },
                                type: "assistant",
                                promptId: "",
                                createdBy: "",
                            }}
                            {...buildAgentPlaceholderConfig}
                        />
                    </ChatProvider>
                </TestChatWrapper>
            </ChatContainer>
        </CreatedPageContainer>
    )
}

export default CreatedPage
